import React from 'react';
import PropTypes from 'prop-types';

// Components
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';

// Constants
import { AMAZON_ORDER_DETAILS_LINK } from 'constants';


export default function AmazonOrderDetailsLink({ vendorOrderId, ...props }) {
  return (
    <a href={`${AMAZON_ORDER_DETAILS_LINK}${vendorOrderId}`} target="_blank" {...props}>
      <Tooltip title="View order details in Amazon" className="inline-block">
        <SVG src="svg/amazon.svg" className="amazon" />
      </Tooltip>
    </a>
  );
}

AmazonOrderDetailsLink.propTypes = {
  vendorOrderId: PropTypes.string
};
